import { useTranslation } from "react-i18next";
import { FaMapMarkerAlt, FaEnvelope, FaPhone } from "react-icons/fa";

export default function ContactMap() {
  const { t } = useTranslation();

  return (
    <section className="ContactMap fade" id="contact">
      <div className="contactmap-content">
        <h2>{t("contact.enter.title")}</h2>
        <p>{t("contact.enter.text")}</p>

        <ul className="contactmap-list">
          <li>
            <FaMapMarkerAlt className="icon pink" />
            <span>{t("contact.address")}</span>
          </li>
          <li>
            <FaEnvelope className="icon green" />
            <span>{t("contact.email")}</span>
          </li>
          <li>
            <FaPhone className="icon yellow" />
            <span>{t("contact.phone1")}</span>
          </li>
          <li>
            <FaPhone className="icon yellow" />
            <span>{t("contact.phone2")}</span>
          </li>
        </ul>
      </div>

      <div className="contactmap-map">
        <iframe
          title="Carte"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2890.658222884257!2d7.2619!3d43.7102!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12cddaa9f1184d91%3A0x908d2b5ff9912cd5!2sNice!5e0!3m2!1sfr!2sfr!4v0000000000"
          loading="lazy"
        />
      </div>
    </section>
  );
}
